// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./mobile-first.css";
import reportWebVitals from "./reportWebVitals";

// Your Google Analytics Tracking ID
const GA_TRACKING_ID = "G-B7BG7CPZ2G";

/**
 * Function to load the Google Analytics script dynamically
 */
const loadGoogleAnalytics = () => {
  return new Promise((resolve) => {
    // Check if GA script is already present
    if (
      !document.querySelector(
        `script[src="https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}"]`
      )
    ) {
      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      script.async = true;
      script.onload = () => {
        initializeGA();
        resolve();
      };
      document.head.appendChild(script);
    } else {
      // If script is already present, just initialize GA
      initializeGA();
      resolve();
    }
  });
};

/**
 * Function to initialize GA after the script has loaded
 */
const initializeGA = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_TRACKING_ID, {
    page_path: window.location.pathname,
  });
};

/**
 * Main function to initialize GA and handle rendering
 */
const init = async () => {
  await loadGoogleAnalytics();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Initialize the app (only once)
init();

reportWebVitals();
